import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert } from "react-bootstrap";
import bg1 from "../assets/img/bg1.jpg";

export default function Register() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    patientNumber: "",
    role: "patient"
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    
    if (formData.password !== formData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    setLoading(true);

    // Simulation d'inscription
    setTimeout(() => {
      setSuccess("Inscription réussie ! Vous pouvez maintenant vous connecter.");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5">CNAMGS Digital</Link>
              <Card.Title>Inscription</Card.Title>
              <Card.Text>Créez votre compte pour accéder à vos services.</Card.Text>
            </Card.Header>
            <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">{success}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <Form.Label>Nom complet</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="name"
                    placeholder="Entrez votre nom complet"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <Form.Label>Adresse email</Form.Label>
                  <Form.Control 
                    type="email" 
                    name="email"
                    placeholder="Entrez votre email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <Form.Label>Numéro d'assuré (optionnel)</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="patientNumber"
                    placeholder="CNAMGS-XXXXXXXX"
                    value={formData.patientNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-4">
                  <Form.Label>Mot de passe</Form.Label>
                  <Form.Control 
                    type="password" 
                    name="password"
                    placeholder="Créez un mot de passe"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <Form.Label>Confirmer le mot de passe</Form.Label>
                  <Form.Control 
                    type="password" 
                    name="confirmPassword"
                    placeholder="Confirmez votre mot de passe"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </div>

                <Button 
                  type="submit" 
                  className="btn-sign w-100" 
                  disabled={loading}
                >
                  {loading ? 'Inscription en cours...' : "S'inscrire"}
                </Button>

                <div className="text-center mt-4">
                  <p className="text-muted mb-0">
                    Vous avez déjà un compte ? 
                    <Link to="/login" className="ms-2">Se connecter</Link>
                  </p>
                </div>
              </Form>
            </Card.Body>
            <Card.Footer className="text-center">
              <small className="text-muted">
                © 2025 CNAMGS Digital - Assurance Maladie du Gabon
              </small>
            </Card.Footer>
          </Card>
        </Col>
        <Col className="d-none d-lg-block">
          <img src={bg1} className="auth-img" alt="CNAMGS" />
        </Col>
      </Row>
    </div>
  );
}